function normalizeInnerSpaces(s) {
  return String(s ?? '').trim().replace(/\s+/g, ' ');
}

export function isValidName40(value, required = false) {
  const s = normalizeInnerSpaces(value);
  if (!s) return !required;
  if (s.length < 1 || s.length > 40) return false;
  return /^[\p{L}\p{M}\s'’-]+$/u.test(s);
}

export function isValidName80(value, required = false) {
  const s = normalizeInnerSpaces(value);
  if (!s) return !required;
  if (s.length < 1 || s.length > 80) return false;
  return /^[\p{L}\p{M}\s'’-]+$/u.test(s);
}

export function isValidEmailRule(value, required = false) {
  const s = String(value ?? '').trim().toLowerCase();
  if (!s) return !required;
  if (s.length < 6 || s.length > 100) return false;
  return /^(?!.*\.\.)([A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*)@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}$/.test(s);
}

export function isValidPhoneRule(value, required = false) {
  const s = String(value ?? '').trim();
  if (!s) return !required;
  const digits = s.replace(/\D/g, '');
  return digits.length >= 6 && digits.length <= 15;
}

export function isValidPassportRule(value, required = false) {
  const s = String(value ?? '').trim().toUpperCase();
  if (!s) return !required;
  if (s.length < 5 || s.length > 20) return false;
  return /^[A-Z0-9]+$/.test(s);
}

export function isValidNieRule(value, required = false) {
  const s = String(value ?? '').trim().toUpperCase();
  if (!s) return !required;
  return /^[XYZ]\d{7}[A-Z]$/.test(s);
}

export function isValidStreetRule(value, required = false) {
  const s = normalizeInnerSpaces(value);
  if (!s) return !required;
  if (s.length < 1 || s.length > 100) return false;
  return /^[\p{L}\p{M}0-9\s.,]+$/u.test(s);
}

export function isValidStreetNumberRule(value, required = false) {
  const s = String(value ?? '').trim();
  if (!s) return !required;
  if (s.length < 1 || s.length > 10) return false;
  return /^[\p{L}\p{M}0-9/]+$/u.test(s);
}

export function isValidCityRule(value, required = false) {
  const s = normalizeInnerSpaces(value);
  if (!s) return !required;
  if (s.length < 1 || s.length > 40) return false;
  return /^[\p{L}\p{M}\s'’-]+$/u.test(s);
}

export function isValidPostalCodeRule(value, required = false) {
  const s = String(value ?? '').trim();
  if (!s) return !required;
  return /^\d{5}$/.test(s);
}

function parseKnownDate(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return null;

  // yyyy-mm-dd
  let m = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) {
    const y = Number(m[1]);
    const mo = Number(m[2]);
    const d = Number(m[3]);
    const dt = new Date(y, mo - 1, d);
    if (dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d) return dt;
    return null;
  }

  // dd/mm/yyyy or dd-mm-yyyy
  m = raw.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (m) {
    const d = Number(m[1]);
    const mo = Number(m[2]);
    const y = Number(m[3]);
    const dt = new Date(y, mo - 1, d);
    if (dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d) return dt;
    return null;
  }

  return null;
}

export function isValidAdultDobRule(value) {
  const dt = parseKnownDate(value);
  if (!dt) return false;
  const today = new Date();
  const minAdult = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  return dt <= minAdult;
}
